import { MenuObject } from '@rbi-ctg/menu';
import {
  ICaloriesFragment,
  IEntity,
  IPricingAndAvailabilityFragment,
  IStoreMenuQuery,
} from 'generated/graphql-gateway';
import {
  IGetComboWithVendorConfigQuery,
  IGetItemWithVendorConfigQuery,
  IGetMenuSectionsQuery,
  IGetPickerQuery,
} from 'generated/sanity-graphql';
import { IDayPartBoundary, IValidDayPart } from 'state/day-part/hooks/use-active-day-parts';

export enum DAY_PART_SELECTIONS {
  DAYTIME_KEY = 'Main Menu',
  BREAKFAST_KEY = 'Breakfast',
  ALL_KEY = 'all',
  BURGERS_FOR_BREAKFAST = 'Burgers for Breakfast',
}

export interface IGetDayPart {
  currentDayPart: DAY_PART_SELECTIONS | null;
  dayParts: IValidDayPart[];
}

export interface IUseDayPart {
  breakfastInterval: IDayPartBoundary | undefined;
  mainMenuInterval: IDayPartBoundary | undefined;
  setDayPart: (newDayPart: DAY_PART_SELECTIONS) => void;
  getDayPart: () => IGetDayPart;
}

export interface IMenuObjectState {
  data: MenuObject | null;
  loading: boolean;
}

interface IGetMainMenuParams {
  menuId?: string;
  region?: string;
  storeId?: string | null;
  forceRefresh?: boolean;
}

export interface IGetStoreMenuParams {
  forceRefresh?: boolean;
  region: string;
  storeId: string;
}

export interface IMainMenuContext extends IUseDayPart {
  getStoreMenu: (params: IGetStoreMenuParams) => Promise<void>;
  getMenuObject(id: string): IMenuObjectState;
  getMainMenu(params: IGetMainMenuParams): void;
  getPricingAndAvailability: (id: string) => IPricingAndAvailabilityFragment | null | undefined;
  getCalories: (item: MenuObject) => ICaloriesFragment['calories'] | null;
  getStoreMenuEntity: (id: string) => IEntity | null | undefined;
  data: IGetMenuSectionsQuery | undefined;
  loading: boolean;
  hasError: boolean;
  getSection: (id: string) => Promise<void>;
  getPickerDetail: (id: string) => Promise<void>;
  getItemDetail: (id: string) => Promise<void>;
  getComboDetail: (id: string) => Promise<void>;
  pickerLoading: boolean;
  pickerData: IGetPickerQuery | undefined;
  comboLoading: boolean;
  comboData: IGetComboWithVendorConfigQuery | undefined;
  itemLoading: boolean;
  itemData: IGetItemWithVendorConfigQuery | undefined;
  storeMenuLoading: boolean;
  storeMenuCalled: boolean;
  storeMenuData: IStoreMenuQuery | undefined;
  setIsOffer: (isOffer: boolean) => void;
  isOffer: boolean;
  isMenuLoading: boolean;
}
